import React, { useEffect, useState } from 'react';
import { Platform } from 'react-native'
import BottomSheetContainer from '../Bottomsheet/Bottomsheet.web';
import { hideErrorSheet } from '../../store/slices/errorSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Button from '../Button/Button';
import { useDarkMode } from '@app/utils';
import { themeColorSet, ThemedText, ThemedView } from '@app/theme';
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';



const ErrorBottomSheet = () => {
  const errorSheetDetail = useAppSelector(state => state.errorSheet);
  const isDarkMode = useDarkMode()

  const dispatch = useAppDispatch();
  const { isErrorSheetVisible, errorType, errorMessage, closeOnBackdropPress, routeName, errorHeading, isWarning = false, showErrorHeading = true, btnName = 'Edit details', showMsgBg = false, ctaLabel, ctaAction } =
    errorSheetDetail;


  const [visible, setVisible] = useState(false);

  // this is a hack for a bug in ios https://github.com/ammarahm-ed/react-native-actions-sheet/issues/214
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (isErrorSheetVisible) {
      if (Platform.OS === 'ios') {
        timeout = setTimeout(() => {
          setVisible(true);
        }, 300);
      } else {
        setVisible(true);
      }
    } else {
      setVisible(false);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isErrorSheetVisible]);




  useEffect(() => {
    return () => {
      if (isErrorSheetVisible) {
        dispatch(hideErrorSheet());
      }
    };

  }, [isErrorSheetVisible]);

  const closeBottomSheet = () => {
    dispatch(hideErrorSheet());
  };
  return (
    <BottomSheetContainer
      isVisible={isErrorSheetVisible}
      close={closeBottomSheet}
      closeOnBackdropPress={closeOnBackdropPress ?? true}
      borderTopRightRadius={10}
      borderTopLeftRadius={10}
      containerStyle={{ backgroundColor : themeColorSet['bg-fill-primary']}}>
      <ThemedView alignItems='center' justifyContent='center' p="lg">
        <ThemedView my="sm" mb="2xl">
          {isWarning ?
            <WarningCircle size={60} weight='fill' color={themeColorSet['icon-warning']} /> :
            <WarningCircle size={48} weight='fill' color={themeColorSet['icon-error']} />
          }
        </ThemedView>
        {showErrorHeading && <ThemedText variant='h5s' textAlign='center' color='text-primary'>{errorHeading || "Something went wrong"}</ThemedText>}
        <ThemedView mt="sm" mb="2xl" backgroundColor={showMsgBg ? 'bg-fill-info' : 'bg-fill-primary'} p="sm" borderRadius='sm' width={'100%'}>
          <ThemedText textAlign='center' color='text-secondary' variant='b3r'>
            {errorMessage || 'Unable to process your request. Please try again after sometime.'}
          </ThemedText>
        </ThemedView>
        <Button
          eventName={routeName + '_EDIT'}
          label={Boolean(btnName) ? btnName : ctaLabel ?? 'Edit details'}
          type={'SOLID'}
          handlePress={ctaAction ?? closeBottomSheet}
        />
      </ThemedView>
    </BottomSheetContainer>
  );
};

export default ErrorBottomSheet;
